/* istanbul ignore file */

import { Injectable } from '@angular/core';

@Injectable()
export class MockCookiesService {
  public getAll() {
    return {};
  }

  public get() {
    return '';
  }
} /* istanbul ignore next */
